import TenderDetailView from './TenderDetail';

export default TenderDetailView;
